import TableReport from "../../../common/table/table";
import MessageEmptyData from "../../../common/messageEmptyData";
import {isEmpty} from "lodash"
import {tableColumns} from "./tableColumns";
import AverageHoursBarChart from './charts/averageHoursBarChart';
import SummaryOfHoursBarChart from './charts/summaryOfHoursBarChart';
import { TableStyle } from './tableStyle';

/**
 * Body component for average downtime by rig.
 * @param prop
 * @returns {JSX.Element|null}
 * @constructor
 */
const AverageDowntimeByRigBody = (prop) => {
    const {filters, data} = prop;

    if (!filters.isSubmitted) {
        return null;
    }

    if (isEmpty(data.table_data)) {
        return <MessageEmptyData/>;
    }

    return (
        <div className="container-fluid overflow-auto">
            <TableStyle>
                <TableReport
                    columns={tableColumns}
                    data={data.table_data}
                    exportOptions={{pdf: false, xlsx: true, csv: true}}
                    getExportFileName={() => 'average_downtime_by_rig'}
                    scrollable={true}
                    lastRowsToExcludeFromSort={true}
                />
            </TableStyle>
            <div className="row mt-3">
                {
                    data.chart_average_hours_by_period && (
                        <div className="col-md-6 mb-12">
                            <AverageHoursBarChart data={data.chart_average_hours_by_period} />
                        </div>
                    )
                }
                {
                    data.chart_summary_of_hours_by_description && (
                        <div className="col-md-6 mb-12">
                            <SummaryOfHoursBarChart data={data.chart_summary_of_hours_by_description} />
                        </div>
                    )
                }
            </div>
        </div>
    );
}

export default AverageDowntimeByRigBody;
